import { Issue } from '@damofire/data-watson';
import { CanvasCoordinates, CanvasDisplayPrecision, CanvasRenderer, CanvasRenderingCtx } from '@damofire/uix-commons';
import { DEFAULT_ISSUE_CFG, SELECTED_ISSUE_SCALE } from './canvas.cfg';

export const FULL_CIRCLE_END_ANGLE = Math.PI * 2;

export interface LayoutIssues extends CanvasCoordinates {
  fill: string | HTMLImageElement;
  assetId: string;
  issues: Issue[];
  filteredIssues: Issue[];
  radius: number;
}

export class IssueLayoutRenderer extends CanvasRenderer {
  private _selected = false;

  constructor(
    private readonly ctx: CanvasRenderingContext2D,
    private readonly issues: LayoutIssues,
  ) {
    super();
  }

  draw(renderingCtx: CanvasRenderingCtx): void {
    if (this.issues.filteredIssues?.length) {
      this.ctx.save();

      this.issues.radius = DEFAULT_ISSUE_CFG.radius * (this._selected ? SELECTED_ISSUE_SCALE : scaleByCount(this.issues.filteredIssues.length));

      this.ctx.translate(this.issues.x, this.issues.y);

      if (this._selected) {
        this.ctx.save();
        this.ctx.beginPath();
        this.ctx.arc(0, 0, this.issues.radius + 10, 0, FULL_CIRCLE_END_ANGLE, false);
        this.ctx.globalAlpha = 0.6;
        this.ctx.fillStyle = this.issues.fill as string;
        this.ctx.fill();
        this.ctx.closePath();
        this.ctx.restore();
      }

      this.ctx.beginPath();
      this.ctx.arc(0, 0, this.issues.radius, 0, FULL_CIRCLE_END_ANGLE, false);
      this.ctx.fillStyle = this.issues.fill as string;
      this.ctx.fill();
      this.ctx.closePath();

      if (renderingCtx.precision === CanvasDisplayPrecision.FULL) {
        this.ctx.fillStyle = 'white';
        this.ctx.textAlign = 'center';
        this.ctx.textBaseline = 'middle';
        this.ctx.font = `bold ${this.issues.radius}px Open Sans`;
        this.ctx.scale(1, -1);
        this.ctx.rotate(-renderingCtx.rx * (Math.PI / 180));
        this.ctx.fillText(`${this.issues.filteredIssues.length}`, 0, 0);
      }

      this.ctx.restore();
    }
  }

  set selected(selected: boolean) {
    this._selected = selected;
  }

  layoutIssues(): LayoutIssues {
    return this.issues;
  }

  allIssues(): Issue[] {
    return Object.assign([], this.issues.issues);
  }

  updateIssues(issues: Issue[]): void {
    this.issues.issues = Object.assign([], issues);
    this.issues.filteredIssues = Object.assign([], issues);
  }

  updateFilteredIssues(issues: Issue[]): void {
    this.issues.filteredIssues = Object.assign([], issues);
  }

  updateFill(fill: string): void {
    this.issues.fill = fill;
  }
}
export function scaleByCount(count: number): number {
  let scale = 1;

  if (count === 2) {
    scale = 1.3;
  } else if (count === 3) {
    scale = 1.5;
  } else if (count >= 4) {
    scale = 2;
  }

  return scale;
}
